export const SAMPLE_DATA_BANNER_HEIGHT = 36;

export function SampleDataBanner({ onConnect }) {
  const href = "/settings?tab=database-connection";

  const handleClick = (e) => {
    if (onConnect) {
      e.preventDefault();
      onConnect();
    }
  };

  return (
    <div className="sticky top-0 z-[60] flex h-9 w-full items-center justify-between gap-3 bg-purple-600 px-4 text-white sm:px-6">
      <div className="flex items-center gap-2 min-w-0">
        <svg
          className="size-4 shrink-0 text-purple-100"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
          />
        </svg>
        <span className="truncate text-xs font-medium sm:text-sm">
          You're viewing sample data.
        </span>
      </div>
      <a
        href={href}
        onClick={handleClick}
        className="inline-flex shrink-0 items-center gap-1 rounded-full bg-white/15 px-3 py-1 text-xs font-semibold text-white hover:bg-white/25 transition-colors"
      >
        Connect real database
        <span aria-hidden="true">&rarr;</span>
      </a>
    </div>
  );
}
